import {PATH} from "./UserModalController";
import ModalCloseBtn from "./ui/ModalCloseBtn";
import {isHomeScreen, setModalPath} from "./utils";
import {Modal} from "react-bootstrap";
import Title from "../../layout/Title";
import {t} from "../../i18n";
import FormContainer from "../../layout/FormContainer";
import {useHistory} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {openFreshChat} from "../../ui/FreshChatWidget";
import {clearManualApprovalRequired, handleModalPath} from "../../user/UserActions";
import {useDispatch} from "react-redux";
import {BrandButton} from "../../ui/buttons/buttons";
import {useAppSelector} from "../../RootReducer";

export const ManualApprovalModal = () => {
    const dispatch = useDispatch();
    const homeScreen = isHomeScreen();
    const history = useHistory();
    const ref = useRef(null);
    const [submitting, setSubmitting] = useState(false);
    const freshChatEnabled = useAppSelector(state => state.settings?.settings?.freshChatEnabled);

    useEffect(()=>{
        if(window.fcWidget) {
            window.fcWidget.on("widget:opened", ()=>{
                dispatch(clearManualApprovalRequired());
                setModalPath({path: undefined, history});
            })
        }
    },[dispatch]);
    const requestApproval = () => {
        setSubmitting(true);
        openFreshChat();
    }
    return (
        <div className={`modal-wrapper ${PATH.VERIFY_EMAIL} ${!homeScreen ? "active" : null}`} ref={!homeScreen ? ref : null}>
            {!homeScreen && <ModalCloseBtn onClick={()=>setModalPath({path: undefined, history})}/>}
            <div className="modal-container">
                <Modal.Header>
                    <Title animate={true} title={t("user.manual-approval.title")} />
                </Modal.Header>
                <Modal.Body>
                    <div className={"manual-approval"}>
                        <div className={"manual-approval-text"}>
                            {t("user.manual-approval.text")}
                        </div>
                        {freshChatEnabled && (
                            <BrandButton loading={submitting} className={"btn btn-cta"} onClick={requestApproval}>
                                {t("user.manual-approval.button")}
                            </BrandButton>
                        )}
                    </div>
                </Modal.Body>
            </div>
        </div>
    )
}